export default __webpack_public_path__ + "images/1715d81b8c83b540af6151c4b4016a81.svg";